// removed by extract-text-webpack-plugin
module.exports = {"Card":"_yQXJl","CardBackgroundOne":"_36g2z","CardBackgroundTwo":"_1QxwT","CardFront":"_1Rxox","CardBack":"_3t9cm","CardImage":"_28SXi","CardNumber":"_1wAhk","CardNumberActive":"_1xscO","CardStripe":"_1k1aB","CardSignature":"_jqZJq","CardName":"_3qvUB","CardDate":"_11cIh","CardTextLight":"_2eA7i","CardTextLightActive":"_1EzrY","CardFlipped":"_32APz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Card/Card.scss
// module id = 616
// module chunks = 0